/* eslint-disable */
import { Typography, TextField, FormControl, Select, Box, CircularProgress, Button, Grid, InputLabel } from "@mui/material";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { UPDATE_PROJECT, UpdateDataUserVerify } from "../../gql/mutations/userWebSiteVisit";
import { ownwerDomainCreate, resetCustomizer } from "../../redux/action";
import { validateString } from "../Validate/validate";
import { usePopup } from "../../context/commonPop";
import { GetUserWebsiteData } from "../../hooks/userWebsiteData";
import { extractDomainAndProtocol } from "../../common/utils";
import { Container } from "@mui/system";
import MessagePopUp from "../Modal/messagePopUp";
// import darkLogoImage from "../../Images/hotSpotLogoBlue.svg";
import { LocalStorageKey } from "../../common/constant";

import MannualSteps from "./MannualSteps";
import BackButton from "../BackButton/BackButton";
import GreenLogo from "../Logo/GreenLogo";
import LogoutPopUp from "../Modal/LogoutPopupFirst";
import logoutBtn from "../../Images/md-log-out.svg";
import { LOGOUT } from "../../gql/mutations/auth";
import { AuthContext } from "../../AuthContext";
import { ValidationHttp, ValidationUri } from "../../common/validations";
import { SCRAPY_DATA } from "../../gql/queries/userWebSiteList";
import { useSelector } from "react-redux";
import useQuery from "../../hooks/allQuery";

const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: "#EFF3FB",
  paddingTop: "30px",
  paddingBottom: "30px",
  "& .LogoWrapper": {
    textAlign: "center",
    "& img": { width: "105px", height: "auto" },
  },
  "& .logOutBtn": {
    textTransform: "none",
    backgroundColor: "transparent",
    color: "#E83D62",
    borderRadius: "5px",
    boxShadow: "none",
    border: "1.5px solid #E83D62",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "17.64px",
    minWidth: "165px",
    width: "165px",
    padding: "11px 0",
    marginLeft: "45px",
    transition: "0.3s all",
    "@media screen and (max-width:600px)": {
      width: "100px",
      minWidth: "100px  ",
    },
    "& img": {
      marginRight: "8px",
    },
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
      color: "#E83D62",
      transform: "scale(1.05)",
      "& a": { color: "#ff642d" },
      "& svg": { transform: "rotateZ(720deg)" },
    },
    "&:focus": { outline: "none" },
  },
  "& .importProjectbox": {
    backgroundColor: "#fff",
    padding: "20px",
    border: "1px solid #E3E3E3",
    borderRadius: "8px",
    "& .InputWrapper": {
      "& .selectInput": {
        width: "40%",
      },
      "& .MuiFormControl-root": {
        marginTop: "7px",
        "& fieldset": {
          borderColor: " #E3E3E3 !important",
        },
        "&.FullWidthInput": {
          flex: "100%",
        },
        "& label": { lineHeight: 1 },
      },
      "& label": { color: theme.palette.text.primary, fontSize: "12px", fontWeight: 600, lineHeight: "1", textAlign: "left" },
    },
  },
  "& .ImportMainHead": {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
      marginBottom: "20px",
      gap: "20px",
    },
    "& .MainHeading": { color: "#2A3547", textAlign: "center", lineHeight: 1, fontSize: "24px", fontWeight: 700, marginBottom: "10px" },
    "& .SubHeading": {
      color: "#757575",
      textAlign: "center",
      lineHeight: 1,
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  "& .continueBtn": {
    textTransform: "none",
    backgroundColor: "#45C0CB",
    color: "#ffffff",
    borderRadius: "5px",
    boxShadow: "none",
    padding: "12px 22px 10px",
    width: "100%",
    border: "1px solid #45C0CB",
    "&:focus": {
      outline: "0",
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#45C0CB",
    },
    "&.Mui-disabled": {
      opacity: "0.5",
    },
    "& .MuiCircularProgress-circle": {
      color: "#ffffff",
    },
  },
  "& .backBtnBox": {
    position: "absolute",
    top: "20px",
    right: "20px",
  },
  "& .MainHeading h2": {
    color: "#2A3547",
    textAlign: "center",
    lineHeight: 1,
    fontSize: "24px",
    fontWeight: 700,
    marginBottom: "10px",
  },
  "& .SubHeading": {
    color: "#757575",
    textAlign: "center",
    lineHeight: 1,
    fontSize: "14px",
    fontWeight: 500,
  },
}));

const InputWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "15px",
  "& .InputStyleWrapper": {
    width: "calc(50% - 15px)",
    "& .css-px39cz-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled": {
      color: `${theme.palette.text.primary} !important`,

      "& input": {
        color: `${theme.palette.text.primary} !important`,

        "&::placeholder": {
          color: `${theme.palette.text.primary} !important`,
        },
      },
    },
  },
  "&  .menuitem": {
    color: `${theme.palette.text.primary} !important`,
  },
  "& .InputStyleWrapperFullWidth": {
    width: "calc(100% - 15px)",
  },
  "& .selectWrapper": {
    color: theme.palette.text.primary,
    "& .Mui-disabled": {
      textFillColor: theme.palette.text.primary,
      opacity: "0.5",
    },

    "& .css-1wu7ecg-MuiSvgIcon-root-MuiSelect-icon, .css-gofekn-MuiSvgIcon-root-MuiSelect-icon": {
      fill: theme.palette.text.primary,
    },
    "& .css-1b9x3a-MuiInputBase-root-MuiOutlinedInput-root": {
      border: "none",
      "&:hover": {
        border: `1px solid ${theme.palette.text.primary} !important`,
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.text.primary} `,
      "&:hover": {
        border: `1px solid ${theme.palette.text.primary} !important`,
      },
    },
    "& .css-9425fu-MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.text.primary} !important`,
      "&:hover": {
        border: `1px solid ${theme.palette.text.primary} !important `,
      },
    },

    "& input": {
      color: theme.palette.text.primary,
    },
  },
}));

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& h3": {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "25px",
    color: theme.palette.text.primary,
  },
  "& p.Description": {
    fontSize: "16px",
    marginBottom: "20px",
    color: "#757575",
  },
  "& button": {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",

    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
    },
  },
}));

const loderfor = {
  isLoading: false,
  htmlTag: false,
  htmlFile: false,
  dnsLoading: false,
  googleLoding: false,
};
function UpDateChild({ ProjectData }) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(loderfor);
  const [logout, setLogout] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadings, setLoadings] = useState(false);
  const [logOutCall] = useMutation(LOGOUT);
  const { removeAuth } = useContext(AuthContext);
  const { userData } = useSelector(state => state.reducer);
  const { ownerId } = useParams();
  const { allQuery } = useQuery();
  const { handleOpen } = usePopup();
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [updateProject] = useMutation(UPDATE_PROJECT, { fetchPolicy: "network-only" });
  const [UPDATE_USER_WEB_VISIT] = useMutation(UpdateDataUserVerify);
  const [formState, setFormState] = useState({
    scope: "",
    websiteUrl: "",
    projectName: "",
    projectId: "",
  });
  const [errorState, setErrorState] = useState({
    scope: false,
    projectName: false,
    websiteUrl: false,
  });

  const navigate = useNavigate();

  const hashCode = async (website, email) => {
    const str = `${website}${email}`;
    let hash = 0;
    let chr;
    if (str.length === 0) return hash;
    for (let i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0;
    }
    return Math.abs(hash);
  };

  const handleInputChange = event => {
    const { name, value } = event.target;
    setFormState({ ...formState, [name]: value });
  };

  const errCheck = async data => {
    const scope = await validateString(data.scope);
    const projectName = await validateString(data.projectName);
    const websiteUrl = await validateString(data.websiteUrl);

    await setErrorState({
      ...errorState,
      scope,

      websiteUrl,
      projectName,
    });
    if (scope || projectName || websiteUrl) {
      return true;
    }
    return false;
  };
  const findOwnerById = async () => {
    if (ProjectData) {
      setLoader({ ...loader, isLoading: true });
      setLoading(false);
      try {
        // await dispatch(ownwerDomainCreate(ProjectData));
        const { website, projectName, id } = ProjectData || {};
        const { domain, protocol } = extractDomainAndProtocol(website);
        const splitScope = `${protocol}//`;
        setFormState({ ...formState, scope: splitScope, websiteUrl: domain, projectName, projectId: id });
      } catch (error) {
        setLoader({ ...loader, isLoading: false });
        setLoading(false);
        console.log("errdata", error.message);
        handleOpen(true, "Something went wrong please wait some time");
      }
    } else {
      console.log("owner id not found");
    }
  };
  const handleLogout = () => {
    setLogout(true);
  };
  const handleLogoutConfirm = async () => {
    logOutCall({
      variables: {
        token: sessionStorage.getItem(LocalStorageKey.REFRESH_TOKEN) || localStorage.getItem(LocalStorageKey.REFRESH_TOKEN),
      },
      onCompleted: () => {
        removeAuth();
        window.dispatchEvent(new Event("storage"));
        dispatch(logoutUser(true));
        dispatch(resetCustomizer());
        setLogout(false);
        navigate("/");
      },
      onError: error => {
        console.log("error", error);
      },
    });
  };

  const updateProjectData = async payload => {
    setLoadings(true);
    allQuery({
      QUERY: updateProject,
      variables: {
        payload,
      },
      type: "update",
      cacheQueryData: {
        cacheQuery: SCRAPY_DATA,
        variablesCache: {
          params: userData?.id,
        },
      },
      onCompleteFunc: async ({ updateProjectDetails }) => {
        setLoader(false);
        dispatch(ownwerDomainCreate(updateProjectDetails));
        if (updateProjectDetails && updateProjectDetails.id) {
          navigate(`/project-config/${ownerId}`);
        }
        setLoadings(false);
      },
      onErrorFunc: err => {
        setLoader(false);
        handleOpen(true, err.message || "something went wrong please try again later");
        console.log("err createApi", err.message);
        setLoadings(false);
      },
    });
  };
  // const updateMutationWebSite = async payload => {
  //   await UPDATE_USER_WEB_VISIT({
  //     variables: { payload },
  //     onCompleted: ({ updateUserWebSiteVerify }) => {
  //       dispatch(ownwerDomainCreate(updateUserWebSiteVerify));
  //       const { website } = updateUserWebSiteVerify || {};
  //       const { domain, protocol } = extractDomainAndProtocol(website);
  //       setFormState({ ...formState, scope: protocol, websiteUrl: domain });
  //       navigate(`/project-config/${ownerId}`);
  //     },
  //     onError: errdata => {
  //       handleOpen(true, "Something went wrong please wait some time");
  //       console.log("UPDATE_USERVISIT", errdata.message);
  //     },
  //   });
  // };

  const handleSubmit = async event => {
    event.preventDefault();
    setLoading(true); 

    const { projectName, websiteUrl, scope, projectId } = formState || {};
    const status = await errCheck(formState);
    if (!status && formState.scope !== null) {
      if (ValidationHttp({ url: websiteUrl })) {
        const hash = await hashCode(websiteUrl, userData.email);
        const str = `hotspot-${hash}`;
        const payload = {
          id: projectId,
          token: str,
          userId: userData.id,
          projectName,
          website: websiteUrl,
        };
        await updateProjectData(payload);
        setLoading(false);
      } else {
        const Createstr = `${scope}${websiteUrl}`;
        if (ValidationUri({ uri: Createstr }) && scope) {
          const hash = await hashCode(Createstr, userData.email);
          const str = `hotspot-${hash}`;
          const payload = {
            id: projectId,
            token: str,
            userId: userData.id,
            website: Createstr,
            projectName,
          };

          await updateProjectData(payload);
          setLoading(false);
        } else {
          setLoading(false);
          setOpen(true);
          setMessage("Please enter a valid domain or path");
        }
      }
    } else {
      setLoading(false);
      console.log("this not call");
    }
  };

  // const handleSubmit = async event => {
  //   event.preventDefault();
  //   const { projectName } = formState || {};
  //   const status = await errCheck(formState);
  //   if (!status && formState.scope !== null) {
  //     const payload = {
  //       id: ownerId,
  //       projectName,
  //     };
  //     await updateMutationWebSite(payload);
  //   }
  // };
  useEffect(() => {
    findOwnerById();
    // eslint-disable-next-line
  }, [ProjectData]);
  return (
    <SectionWrapper>
      <LogoutPopUp logout={logout} setLogout={setLogout} onLogout={handleLogoutConfirm} />

      <Container>
        <Box sx={{ flexGrow: 1 }}>
          {open && <MessagePopUp message={message} open={open} setOpen={setOpen} />}
          <Grid container spacing={2} mt={0} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Box className="LogoWrapper">
                {/* <Typography component="img" src={darkLogoImage} alt="Logo" /> */}
                <GreenLogo />
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ width: "100%", textAlign: { xs: "center", sm: "end" } }}>
            <Button variant="outlined" color="primary" onClick={handleLogout} className="logOutBtn">
              <Typography component="img" src={logoutBtn} alt="" />
              Logout
            </Button>
          </Box>
          <Grid container spacing={2} mt={0} justifyContent="center">
            <Grid item xs={12} md={12}>
              <Box className="importProjectbox">
                <Grid container spacing={2} mt={0}>
                  <Grid item xs={12}>
                    <Box className="ImportMainHead">
                      {/* <BackButton
                        sx={{
                          marginRight: "-80px",
                          zIndex: 99999999,
                          "@media screen and (max-width:600px)": { marginLeft: "0" },
                          "& button": { marginBottom: "0 !important", backgroundColor: "#45C0CB !important" },
                        }}
                      /> */}
                      <Box sx={{ flex: 1, width: { xs: "100%", sm: "unset" } }}>
                        <Box sx={{ width: { xs: "100%", sm: "50%" }, m: "auto", mb: { xs: "15px", sm: "30px" } }}>
                          <MannualSteps ownerId={ownerId} activeStep={0} isVerified={ProjectData?.isVerified} update={true}/>
                        </Box>
                      </Box>
                    </Box>
                    <Box className="MainHeading">
                      <Typography component={"h2"}>Update your first project</Typography>
                      <Typography className="SubHeading">Set up your website to start analyzing it</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box width="100%" className="InputWrapper" component="form" mb={0} onSubmit={event => handleSubmit(event)}>
                      <Box display="flex" justifyContent="space-between" width="100%" flexDirection={{ xs: "column", sm: "row" }} mb={2} gap={2}>
                        <Box flex={1}>
                          <Typography component={"label"}>Protocols</Typography>
                          <FormControl fullWidth variant="outlined" margin="normal" className="InputStyleWrapper" disabled={loading}>
                            <InputLabel id="protocol-select-label">Select http or https</InputLabel>
                            <Select
                              labelId="protocol-select-label"
                              label="Select http or https"
                              className="selectWrapper"
                              value={formState.scope ?? ""}
                              disabled={loading || ProjectData?.isVerified}
                              onChange={handleInputChange}
                              displayEmpty
                              error={errorState?.scope}
                              name="scope"
                            >
                              <MenuItem value="">None</MenuItem>
                              <MenuItem value="http://">HTTP</MenuItem>
                              <MenuItem value="https://">HTTPS</MenuItem>
                            </Select>
                            <Typography component="span" sx={{ color: "red" }}>
                              {errorState?.scope && "please select this scope"}
                            </Typography>
                          </FormControl>
                        </Box>
                        <Box flex={1}>
                          <Typography component={"label"}>Domain Name</Typography>
                          <TextField
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Enter your domain name"
                            name="websiteUrl"
                            value={formState.websiteUrl}
                            onChange={handleInputChange}
                            error={errorState?.websiteUrl}
                            disabled={loading || ProjectData?.isVerified}
                            placeholder="Domain or path"
                            className="InputStyleWrapper selectWrapper"
                            helperText={errorState.websiteUrl && "Please enter valid domain or path"}
                          />
                        </Box>
                      </Box>
                      <Typography component={"p"} mb={2}>
                        We recommend using the "http + https" protocol along with the non-www version of your domain. You'll get the most complete backlink profile and accurate
                        tracking data this way.
                      </Typography>
                      <Box mb={2}>
                        <Typography component={"label"}>Project Name</Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          margin="normal"
                          label="Enter your project name"
                          name="projectName"
                          disabled={loading}
                          value={formState.projectName}
                          placeholder="Project Name"
                          onChange={handleInputChange}
                          className="InputStyleWrapperFullWidth selectWrapper"
                          error={errorState?.projectName}
                          helperText={errorState.projectName && "Please enter valid project Name"}
                        />
                      </Box>
                      <Button className="continueBtn" type="submit" disabled={loadings}>
                        {loadings ? <CircularProgress size={24} color="inherit" /> : "Update"}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}
function UpdateProject() {
  const { ownerId } = useParams();
  const { ProjectData } = GetUserWebsiteData(ownerId);
  if (ProjectData === null) {
    return <Navigate to={"/"} />;
  }
  if (ProjectData) return <UpDateChild ProjectData={ProjectData} />;
}

export default UpdateProject;
